import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import "bootstrap/dist/css/bootstrap.css";
import iconTrophy from "../../../../Resources/Images/Icon-trophy.svg";
import "./BarraSuperior.css";
import PointsAnimation from "./components/PointsAnimation";
import MenuLiveComponent from "./components/MenuLiveComponent";
import { SHOW_LENGUAJE, SHOW_SEARCH, SWITCHER_WIDTH, MENU_DISPLAY_TOP, ACTIVE_CLASS } from "../../../../Utils/Constants";
import { setNestedPanelMaxHeight } from "../../MenuUtils";
import { LanguagesComponent } from "./components/LanguagesComponent";
import { MULTITENANT_CONSTANTS, TENANT, TENANT_ANDROMEDA } from "../../../../Resources/Multitenant/tenantConstants";
import { URL_HOME, URL_PROFILE, URL_LOGIN } from "../../../../Components/Routes/Location";
import { NavLink } from "react-router-dom";
import { checkMenuActive, getSectionName, isSectionActive, isAnyDescendantActive } from "../../../../Utils/utils";
import { getFileService } from "../../../../services/services";
import SearchLink from "./components/SearchLink";
import { saveUserURLAvatarActionCreator } from "../../../../actions/commonActions";
import {URL_BASE_IMAGE} from "../../../../services/servicesConstants";
import {getToken} from "../../../../Utils/utils";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { isCordovaAvailable } from "../../../../Utils/secureStorageUtil";
import { useRef } from "react";
import useFlyoutPanel, { FLYOUT_PANEL_ATTRIBUTE, FLYOUT_PANEL_SELECTOR, FLYOUT_PLACEMENT_BOTTOM, FLYOUT_PLACEMENT_RIGHT } from "../../../../Utils/Hooks/useFlyoutPanel";
import FlyoutScrollHint from "../../../../Components/common/FlyoutScrollHint";
import useFlyoutTrigger from "../../../../Utils/Hooks/useFlyoutTrigger";
import useIsTouchInput from "../../../../Utils/Hooks/useIsTouchInput";

const TopMenuDropdownItem = ({ item, handleChangeSection, location, sectionSelected, sections, isTouchInput, onNavigate }) => {
  const hasChildren = item.children?.length > 0;
  const itemRef = useRef(null);
  const nestedPanelRef = useRef(null);
  const { isOpen, togglePanel, hoverProps } = useFlyoutTrigger(itemRef, isTouchInput);
  const { style: nestedPanelStyle, hasMoreBelow } = useFlyoutPanel(itemRef, nestedPanelRef, hasChildren && isOpen, FLYOUT_PLACEMENT_RIGHT);

  const handleNavigate = () => {
    handleChangeSection(item.section);
    // El submenú se recoge al elegir destino: a dedo no hay salida del ratón que lo cierre
    onNavigate();
  };

  return (
    <div ref={itemRef} className="TopMenuDropdownItem" {...hoverProps}>
      {hasChildren ? (
        <div
          className={`TopMenuDropdownLink TopMenuDropdownLink--parent ${(isSectionActive(item, location.pathname) || isAnyDescendantActive(item, location.pathname)) ? ACTIVE_CLASS : ""}`}
          onClick={isTouchInput ? togglePanel : undefined}
        >
          <span className="TopMenuDropdownText">{getSectionName(item.section)}</span>
          <ion-icon name="chevron-forward-outline" className="TopMenuDropdownChevron" aria-hidden="true" />
        </div>
      ) : (
        <NavLink
          to={{ pathname: item.url, aboutProps: { dinamic: item.section.screenId } }}
          onClick={handleNavigate}
          className={`TopMenuDropdownLink ${isSectionActive(item, location.pathname) ? ACTIVE_CLASS : ""}`}
        >
          <span className="TopMenuDropdownText">{getSectionName(item.section)}</span>
          <span className="TopMenuDropdownChevronSpacer" aria-hidden="true" />
        </NavLink>
      )}
      {hasChildren && isOpen && (
        <div className="TopMenuNestedPanel" {...FLYOUT_PANEL_ATTRIBUTE} ref={nestedPanelRef} style={nestedPanelStyle}>
          <TopMenuDropdownItems
            items={item.children}
            handleChangeSection={handleChangeSection}
            location={location}
            sectionSelected={sectionSelected}
            sections={sections}
            isTouchInput={isTouchInput}
            onNavigate={onNavigate}
          />
          {hasMoreBelow && <FlyoutScrollHint />}
        </div>
      )}
    </div>
  );
};

const TopMenuDropdownItems = ({ items, handleChangeSection, location, sectionSelected, sections, isTouchInput, onNavigate }) => (
  <>
    {items.map((child, index) => (
      <TopMenuDropdownItem
        key={child.section.name + "-" + index}
        item={child}
        handleChangeSection={handleChangeSection}
        location={location}
        sectionSelected={sectionSelected}
        sections={sections}
        isTouchInput={isTouchInput}
        onNavigate={onNavigate}
      />
    ))}
  </>
);

const TopMenuDropdownPanel = ({ items, handleChangeSection, location, sectionSelected, sections, style, panelRef, hasMoreBelow, isTouchInput, onNavigate }) => (
  <div className="TopMenuDropdownPanel" {...FLYOUT_PANEL_ATTRIBUTE} ref={panelRef} style={style}>
    <TopMenuDropdownItems
      items={items}
      handleChangeSection={handleChangeSection}
      location={location}
      sectionSelected={sectionSelected}
      sections={sections}
      isTouchInput={isTouchInput}
      onNavigate={onNavigate}
    />
    {hasMoreBelow && <FlyoutScrollHint />}
  </div>
);

const TopMenuSectionItem = ({ section, handleChangeSection, location, sectionSelected, sections, isTouchInput }) => {
  const wrapperRef = useRef(null);
  const dropdownPanelRef = useRef(null);
  const hasChildren = section.children?.length > 0;
  const { isOpen, closePanel, togglePanel, hoverProps } = useFlyoutTrigger(wrapperRef, isTouchInput);
  const { style: dropdownStyle, hasMoreBelow } = useFlyoutPanel(wrapperRef, dropdownPanelRef, hasChildren && isOpen, FLYOUT_PLACEMENT_BOTTOM);

  const handleSectionClick = () => {
    handleChangeSection(section.section);
    closePanel();
  };

  return (
    <div ref={wrapperRef} className="TopMenuSectionWrapper" {...hoverProps}>
      {hasChildren ? (
        // Una sección con hijos solo despliega su submenú: el destino está en los hijos
        <div
          className={`TopMenuSectionLink TopMenuSectionLink--parent ${(isSectionActive(section, location.pathname) || isAnyDescendantActive(section, location.pathname)) ? ACTIVE_CLASS : ""} ${isOpen ? "TopMenuSectionLink--open" : ""}`}
          onClick={isTouchInput ? togglePanel : undefined}
        >
          {getSectionName(section.section)}
          <ion-icon name="chevron-down-outline" className="TopMenuSectionChevron" aria-hidden="true" />
        </div>
      ) : (
        <NavLink
          to={{ pathname: section.url, aboutProps: { dinamic: section.section.screenId } }}
          onClick={handleSectionClick}
          className={`TopMenuSectionLink ${isSectionActive(section, location.pathname) ? ACTIVE_CLASS : ""}`}
          isActive={(match, loc) => checkMenuActive(match, loc, section, sectionSelected, sections)}
        >
          {getSectionName(section.section)}
        </NavLink>
      )}
      {hasChildren && isOpen && (
        <TopMenuDropdownPanel
          panelRef={dropdownPanelRef}
          hasMoreBelow={hasMoreBelow}
          items={section.children}
          handleChangeSection={handleChangeSection}
          location={location}
          sectionSelected={sectionSelected}
          sections={sections}
          style={dropdownStyle}
          isTouchInput={isTouchInput}
          onNavigate={closePanel}
        />
      )}
    </div>
  );
};

const BarraSuperior = ({ className, handleChangeSection, sections }) => {
  const history = useHistory();
  const { keycloak } = useKeycloak();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.commonState.userData);
  const {userURLAvatar: userURLAvatarRedux} = useSelector((state) => state.commonState);
  const menuDisplay = useSelector((state) => state.commonState.menuDisplay);
  const sectionSelected = useSelector((state) => state.commonState.sectionSelected);

  const [renderMobileVersion, setRenderMobileVersion] = useState(window.innerWidth <= SWITCHER_WIDTH);
  const [isScrolled, setIsScrolled] = useState(false);
  // En tablet la barra superior se usa a dedo: los submenús no pueden depender del hover
  const isTouchInput = useIsTouchInput();

  // hasTopMenuStyle: para efecto de color/scroll (aplica en móvil y desktop)
  // isTopMenu: para mostrar secciones del menú (solo en desktop)
  const hasTopMenuStyle = menuDisplay === MENU_DISPLAY_TOP;
  const isTopMenu = hasTopMenuStyle && !renderMobileVersion;
  const [showLanguage, setShowLanguage] = useState(false);
  const [userURLAvatar, setUserURLAvatar] = useState("");
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const userAvatarRequested = useRef(false);
  const sectionsRef = useRef(null);

  const isLoginRequired = MULTITENANT_CONSTANTS[TENANT].showLoginButton;

  const handelShow = (value) => {
    if (value === SHOW_LENGUAJE) {
      setShowLanguage(!showLanguage);
    }
  };

  const handleGoToHome = () => {
    if (window.location.pathname !== URL_HOME) {
      history.push(URL_HOME);
    }
  };

  const handleGoToLogin = () => {
    if (isCordovaAvailable()) {
      history.push(URL_LOGIN);
    } else {
      keycloak.login({ locale: MULTITENANT_CONSTANTS[TENANT]?.defaultLocale });
    }
  };

  const updateArrowVisibility = () => {
    const el = sectionsRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const scrollMenuLeft = () => {
    sectionsRef.current?.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollMenuRight = () => {
    sectionsRef.current?.scrollBy({ left: 200, behavior: "smooth" });
  };

  useEffect(() => {
    if (isTopMenu) updateArrowVisibility();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections, isTopMenu]);

  const handleResize = () => {
    setRenderMobileVersion(window.innerWidth <= SWITCHER_WIDTH);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth]);

  // Detectar scroll para cambiar estilo de la barra superior en menú top (aplica en móvil y desktop)
  useEffect(() => {
    if (!hasTopMenuStyle) return;

    const handleScroll = (e) => {
      // El scroll interno de un submenú flotante no es scroll de página: no debe teñir la barra superior
      if (e?.target?.closest?.(FLYOUT_PANEL_SELECTOR)) return;

      // Obtener scrollTop del elemento que dispara el evento o del window
      let scrollTop = 0;
      if (e && e.target && e.target.scrollTop !== undefined) {
        scrollTop = e.target.scrollTop;
      }
      if (scrollTop === 0) {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }
      setIsScrolled(scrollTop > 50);
    };

    // Usar capture para detectar scroll en cualquier elemento
    document.addEventListener("scroll", handleScroll, true);
    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      document.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasTopMenuStyle]);

  const getFileCallback = (response) => {
    setUserURLAvatar(`${URL_BASE_IMAGE}${response.data.data.asset_url}`);
    dispatch(saveUserURLAvatarActionCreator(`${URL_BASE_IMAGE}${response.data.data.asset_url}`));
  };

  useEffect(() => {
    if (!!userURLAvatarRedux) {
      setUserURLAvatar(userURLAvatarRedux);
      return;
    }
    if (!userURLAvatar && !!userData?.avatar) {
      const userToken = getToken(keycloak);
      if (!userAvatarRequested.current) {
        userAvatarRequested.current = true;
        getFileService(MULTITENANT_CONSTANTS[TENANT]?.tenantServer, userData.avatar, userToken, getFileCallback);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, userURLAvatarRedux]);

  // Clases dinámicas para efecto de scroll en menú top (aplica en móvil y desktop)
  const topMenuScrollClass = hasTopMenuStyle ? (isScrolled ? "top-menu-scrolled" : "top-menu-transparent") : "";

  return (
    <div className={`BarraSuperior ${className ?? ""} ${topMenuScrollClass}`}>
      <div onClick={handleGoToHome} className={"LogoContainer"}>
        <div className="Logo-Barra" />
      </div>
      {isTopMenu && sections && (
        <div className="TopMenuSectionsWrapper">
          {showLeftArrow && (
            <button className="TopMenuArrow TopMenuArrow--left" onClick={scrollMenuLeft} aria-label="Scroll izquierda">
              <ion-icon name="chevron-back-outline" />
            </button>
          )}
          <div className="TopMenuSectionsInBar" ref={sectionsRef} onScroll={updateArrowVisibility}>
            {sections.map((section, index) => (
              <React.Fragment key={section.section.name + "-" + index}>
                {index > 0 && <span className="TopMenuSeparator">|</span>}
                <TopMenuSectionItem
                  section={section}
                  handleChangeSection={handleChangeSection}
                  location={location}
                  sectionSelected={sectionSelected}
                  sections={sections}
                  isTouchInput={isTouchInput}
                />
              </React.Fragment>
            ))}
          </div>
          {showRightArrow && (
            <button className="TopMenuArrow TopMenuArrow--right" onClick={scrollMenuRight} aria-label="Scroll derecha">
              <ion-icon name="chevron-forward-outline" />
            </button>
          )}
        </div>
      )}
      <div className={"groupOptions"}>
        <div className="SearchBarWrapper">
          <div className="SearchBarContainer">
            <SearchLink />
          </div>
        </div>
        {userURLAvatar && (!!keycloak?.authenticated) && (
          <div className="Usuario">
            <div className={"UserSeccion"}>
              <Link to={URL_PROFILE}>
                <img className="AvatarMenu" src={userURLAvatar} alt="Usuario" />
                {MULTITENANT_CONSTANTS[TENANT]?.gamification && userData?.points && (
                  <div className="RankingMenu">
                    <img className="TrophyMenu" src={iconTrophy} alt="IconTropy" />
                    <PointsAnimation userPoints={userData.points} />
                  </div>
                )}
              </Link>
            </div>
          </div>
        )}
        {!keycloak?.authenticated && isLoginRequired && (
          (!renderMobileVersion || (renderMobileVersion && MULTITENANT_CONSTANTS[TENANT]?.showLoginButtonInMobile)) && (
            <div className="Usuario">
              {renderMobileVersion && TENANT !== TENANT_ANDROMEDA ? (
                <div onClick={handleGoToLogin} className={"LoginButton"}>
                  <ion-icon name="log-in-outline" aria-label={t("user.login")} />
                </div>
              ) : (
                <div onClick={handleGoToLogin} className={"LoginButton"}>
                  {t("user.login")}
                </div>
              )}
            </div>
          )
          )}
        <LanguagesComponent show={showLanguage} handelShow={handelShow} renderMobileVersion={renderMobileVersion} />
        <OverlayTrigger
          delay={{ hide: 450, show: 300 }}
          placement="bottom"
          overlay={(props) => <Tooltip {...props}>{t("subtitle.LIVE")}</Tooltip>}
        >
          <MenuLiveComponent
            userAge={userData.role?.maxAge}
            rol={userData.role}
            theme={keycloak.clientId}
            handleChangeSection={handleChangeSection}
          />
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default BarraSuperior;
